module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
    staticClass: "content-wrapper cotacao-main-container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "none",
      "background": "rgba(255, 255, 255, 0.7)",
      "z-index": "1000"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin",
    staticStyle: {
      "top": "50%",
      "left": "50%",
      "position": "absolute",
      "font-size": "30px"
    }
  })]), _vm._v(" "), _c('vue-headful', {
    attrs: {
      "title": 'SGP - GERENCIAMENTO DE ACESSO DE COTAÇÃO AUTOMÁTICA'
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "content-header"
  }, [_vm._m(0), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": [{
        text: 'Inicial',
        href: '/'
      }, {
        text: 'Cadastro',
        href: '#'
      }, {
        text: 'ODS',
        active: true
      }]
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column all-centered cotacao-content"
  }, [_c('div', {
    staticClass: "row-flex centered-start button-row"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.toggleEdicao(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n          Autorizar Acesso")])]), _vm._v(" "), (_vm.editando) ? _c('div', {
    staticClass: "column start-centered cotacao-restricao"
  }, [_c('div', {
    staticClass: "restricao-row"
  }, [_c('label', [_vm._v(" Selecione o Escopo do Acesso: ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tipoSelecionado),
      expression: "tipoSelecionado"
    }],
    staticClass: "form-control hidden-print",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.tipoSelecionado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.buscaOptions()
      }]
    }
  }, _vm._l((_vm.tipos), function(tipo) {
    return _c('option', {
      domProps: {
        "value": tipo
      }
    }, [_vm._v(_vm._s(tipo))])
  }), 0)]), _vm._v(" "), (_vm.tipoSelecionado === 'EDITAL') ? _c('div', {
    staticClass: "restricao-row"
  }, [_c('label', [_vm._v(" Selecione o Edital: ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editalSelecionado),
      expression: "editalSelecionado"
    }],
    staticClass: "form-control hidden-print",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.editalSelecionado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {}]
    }
  }, _vm._l((_vm.editais), function(edital) {
    return _c('option', {
      domProps: {
        "value": edital
      }
    }, [_vm._v(_vm._s(edital.id) + " | " + _vm._s(edital.ds_numero_edital))])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.tipoSelecionado === 'PROPOSTA') ? _c('div', {
    staticClass: "restricao-row"
  }, [_c('label', [_vm._v(" Selecione a Proposta: ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propostaSelecionada),
      expression: "propostaSelecionada"
    }],
    staticClass: "form-control hidden-print",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.propostaSelecionada = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {}]
    }
  }, _vm._l((_vm.propostas), function(proposta) {
    return _c('option', {
      domProps: {
        "value": proposta
      }
    }, [_vm._v(_vm._s(proposta.id) + " | " + _vm._s(proposta.ds_nome))])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.tipoSelecionado === 'EXCECAO EDITAL') ? _c('div', {
    staticClass: "restricao-row"
  }, [_c('label', [_vm._v(" Selecione a Proposta: ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propostaSelecionada),
      expression: "propostaSelecionada"
    }],
    staticClass: "form-control hidden-print",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.propostaSelecionada = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {}]
    }
  }, _vm._l((_vm.propostas), function(proposta) {
    return _c('option', {
      domProps: {
        "value": proposta
      }
    }, [_vm._v(_vm._s(proposta.id) + " | " + _vm._s(proposta.ds_nome))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "restricao-row"
  }, [_c('label', [_vm._v("Justificativa:")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.justificativa),
      expression: "justificativa"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "descricao"
    },
    domProps: {
      "value": (_vm.justificativa)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.justificativa = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row-flex centered-start button-row"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.gravaRestricao()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n              Salvar\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning btn-flat",
    attrs: {
      "color": "error"
    },
    on: {
      "click": function($event) {
        return _vm.toggleEdicao(false)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n              Cancelar\n            ")])])]) : _vm._e(), _vm._v(" "), _c('b-container', {
    staticClass: "tabela-restricao",
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "bordered": _vm.table.bordered,
      "items": _vm.table.items,
      "hover": _vm.table.hover,
      "fields": _vm.table.fields,
      "filter": _vm.table.filter,
      "current-page": _vm.table.currentPage,
      "per-page": _vm.table.perPage,
      "sort-by": _vm.table.sortBy,
      "sort-desc": _vm.table.sortDesc,
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "ativo",
      fn: function(row) {
        return [_c('i', {
          class: ['fa fa-circle ', row.value ? 'text-green' : 'text-red'],
          staticStyle: {
            "cursor": "pointer"
          },
          attrs: {
            "aria-hidden": "true"
          },
          on: {
            "click": function($event) {
              return _vm.ativaDesativaRestricao(row.item)
            }
          }
        })]
      }
    }, {
      key: "updated_at",
      fn: function(row) {
        return [_vm._v("\n                " + _vm._s(_vm._f("moment")(row.value, "L")) + "\n            ")]
      }
    }], null, false, 2617057919)
  })], 1)], 1)], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('span', [_vm._v("Gerenciamento de Acesso - Cotação Automática")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-518ddd74!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/cotacaoExcecoes.vue
// module id = 1895
// module chunks = 2